import { render } from "./MovAlmacenList.vue?vue&type=template&id=d9f38158&scoped=true"
import script from "./MovAlmacenList.vue?vue&type=script&lang=js"
export * from "./MovAlmacenList.vue?vue&type=script&lang=js"

import "./MovAlmacenList.vue?vue&type=style&index=0&id=d9f38158&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9f38158"]])

export default __exports__